import type { HierarchyNode } from '../../types/exploration';

export const BUBBLE_PAGE_SIZE = 100;

export function hierarchyCapKey(pathPrefix: string, node: HierarchyNode): string {
  const segment =
    node.type === 'volume' && node.volume?.ebsId
      ? `volume:${node.volume.ebsId}`
      : `${node.type}:${node.name}`;
  return `${pathPrefix}/${segment}`;
}

export function applyBubbleCaps(
  node: HierarchyNode,
  pathPrefix: string,
  overflowPages: Record<string, number> | undefined,
): void {
  if (!node.children || node.children.length === 0) return;

  const pages = overflowPages ?? {};
  const parentKey = pathPrefix;
  const pageIndex = pages[parentKey] ?? 0;
  const pageLimit = BUBBLE_PAGE_SIZE * (pageIndex + 1);

  const realChildren = node.children.filter((c) => !c._isOverflow);
  if (realChildren.length === 0) return;

  const sorted = [...realChildren].sort((a, b) => (b.value || 0) - (a.value || 0));
  const kept = sorted.slice(0, pageLimit);

  if (kept.length < sorted.length) {
    const rest = sorted.slice(pageLimit);
    const hiddenValue = rest.reduce((s, n) => s + (n.value || 0), 0);
    kept.push({
      name: `+ ${rest.length} More`,
      type: 'overflow',
      _isOverflow: true,
      _hidden: rest.length,
      _overflowExpandable: true,
      _overflowParentKey: parentKey,
      _overflowChildren: rest,
      value:
        hiddenValue > 0
          ? hiddenValue
          : kept[kept.length - 1]
            ? (kept[kept.length - 1].value || 1) * 0.2
            : 1,
    });
  }

  node.children = kept;
  for (const child of kept) {
    if (child._isOverflow) continue;
    applyBubbleCaps(child, hierarchyCapKey(pathPrefix, child), pages);
  }
}
